
// Form validation
const validate = (values) => {
  // console.log(values);
  const error = {};
  if (!values.Questions) {
    error.Questions = 'Please select a question';
  }
  if (!values.Answer) {
    error.Answer = 'Please fill the answer';
  } else if (values.Answer && values.Answer.trim() === '') {
    error.Answer = 'Answer can\'t be blank';
  }
  if (!values.Question1) {
    error.Question1 = 'Please answer the question';
  } else if (values.Question1 && values.Question1.trim() === '') {
    error.Question1 = 'Answer can\'t be blank';
  }
  if (!values.Question2) {
    error.Question2 = 'Please answer the question';
  } else if (values.Question2 && values.Question2.trim() === '') {
    error.Question2 = 'Answer can\'t be blank';
  }
  if (!values.Question3) {
    error.Question3 = 'Please answer the question';
  } else if (values.Question3 && values.Question3.trim() === '') {
    error.Question3 = 'Answer can\'t be blank';
  }
  if (!values.Question4) {
    error.Question4 = 'Please answer the question';
  } else if (values.Question4 && values.Question4.trim() === '') {
    error.Question4 = 'Answer can\'t be blank';
  }
  if (!values.Question5) {
    error.Question5 = 'Please answer the question';
  } else if (values.Question5 && values.Question5.trim() === '') {
    error.Question5 = 'Answer can\'t be blank';
  }
  if (!values.Question6) {
    error.Question6 = 'Please answer the question';
  } else if (values.Question6 && values.Question6.trim() === '') {
    error.Question6 = 'Answer can\'t be blank';
  }
  if (!values.Question7) {
    error.Question7 = 'Please answer the question';
  } else if (values.Question7 && values.Question7.trim() === '') {
    error.Question7 = 'Answer can\'t be blank';
  }
  if (!values.Question8) {
    error.Question8 = 'Please answer the question';
  } else if (values.Question8 && values.Question8.trim() === '') {
    error.Question8 = 'Answer can\'t be blank';
  }

  return error;
};

export default validate;




// WEBPACK FOOTER //
// ./src/modules/SecurityQuestions/validate.js